// extracted by mini-css-extract-plugin
export default {"description":"profileInformation_description__hZA+1"};